import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchInactiveStudents = createAsyncThunk(
  "inactiveStudents/fetchInactiveStudents",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${server}/all_data_of_disabledstudent_mongodb`,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        }
      );
      const data = response.data?.["body-json"]?.body?.data;
      if (data) {
        return data;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching inactive students:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const inactiveStudentsSlice = createSlice({
  name: "inactiveStudents",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInactiveStudents.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchInactiveStudents.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchInactiveStudents.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default inactiveStudentsSlice.reducer;
